import React          from 'react';
import * as PropTypes from 'prop-types';

import RangeSlider from './base/RangeSlider';

const RenderBaseRangeSlider = props => {
  const {
          data,
          disabled,
          value,
          step,
          onChange,
        }        = props;
  const minValue = data[0];
  const maxValue = data[data.length - 1];

  return (
    <RangeSlider
      disable={disabled}
      value={value}
      minValue={+minValue}
      maxValue={+maxValue}
      step={step}
      onChange={onChange}
      ruler={false}
      fromTo={true}
      currency={true}
    />
  );
};

RenderBaseRangeSlider.defaultProps = {
  disable: false,
  step:    1,
};

RenderBaseRangeSlider.propTypes = {
  data:     PropTypes.array.isRequired,
  disable:  PropTypes.bool,
  value:    PropTypes.object.isRequired,
  step:     PropTypes.number,
  onChange: PropTypes.func.isRequired,
};

export default RenderBaseRangeSlider;